import { render, staticRenderFns } from "./loginjudge.vue?vue&type=template&id=2c1f8d08&scoped=true&"
import script from "./loginjudge.vue?vue&type=script&lang=js&"
export * from "./loginjudge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f8d08",
  null
  
)

export default component.exports